"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionedInstances = exports.managedAPIInstances = exports.isFetchingAPIInstanceList = exports.isCreatingInstance = exports.instancesLoadingState = exports.hasOnlyPrivateInstances = exports.hasInstances = exports.externalInstances = exports.apiInstances = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _reselect = require("reselect");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var externalInstances = exports.externalInstances = (0, _reselect.createSelector)(function (state) {
  return state.apiInstances.data;
}, function (state, params) {
  return params;
}, function (instancesData, _ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId,
    versionGroup = _ref.versionGroup;
  return instancesData.external["".concat(groupId, "/").concat(assetId, "/").concat(versionGroup)];
});
var versionedInstances = exports.versionedInstances = (0, _reselect.createSelector)(_exchangeUiPortalsStore.selectors.selectAsset, function (state) {
  return state.apiInstances.data;
}, function (state, params) {
  return params;
}, function (asset, instancesData, _ref2) {
  var _instancesData$versio;
  var groupId = _ref2.groupId,
    assetId = _ref2.assetId,
    minorVersion = _ref2.minorVersion;
  return (_instancesData$versio = instancesData.versioned["".concat(groupId, "/").concat(assetId, "/").concat(minorVersion)]) === null || _instancesData$versio === void 0 ? void 0 : _instancesData$versio.map(function (instance) {
    return instance.type === 'mocked' ? _objectSpread(_objectSpread({}, instance), {}, {
      isPublic: !!(asset !== null && asset !== void 0 && asset.isPublic)
    }) : instance;
  });
});
var apiInstances = exports.apiInstances = (0, _reselect.createSelector)(versionedInstances, externalInstances, function ($versionedInstances, $externalInstances) {
  return [].concat((0, _toConsumableArray2.default)($versionedInstances || []), (0, _toConsumableArray2.default)($externalInstances || []));
});
var managedAPIInstances = exports.managedAPIInstances = (0, _reselect.createSelector)(apiInstances, function ($apiInstances) {
  return $apiInstances.filter(function (_ref3) {
    var type = _ref3.type;
    return type === 'managed';
  });
});
var instancesLoadingState = exports.instancesLoadingState = function instancesLoadingState(state) {
  return state.apiInstances.ui.instances;
};
var hasOnlyPrivateInstances = exports.hasOnlyPrivateInstances = (0, _reselect.createSelector)(externalInstances, versionedInstances, function () {
  var external = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var versioned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var instances = versioned.filter(function (_ref4) {
    var type = _ref4.type;
    return type !== 'mocked';
  }).concat(external);
  return instances.length > 0 && instances.every(function (_ref5) {
    var isPublic = _ref5.isPublic;
    return !isPublic;
  });
});
var hasInstances = exports.hasInstances = (0, _reselect.createSelector)(apiInstances, function (instances) {
  return instances.length > 0;
});
var isCreatingInstance = exports.isCreatingInstance = function isCreatingInstance(state) {
  return state.apiInstances.ui.isCreatingInstance;
};
var isFetchingAPIInstanceList = exports.isFetchingAPIInstanceList = function isFetchingAPIInstanceList(state) {
  return state.apiInstances.ui.isFetchingList;
};
//# sourceMappingURL=selectors.js.map